import {
  Box,
  Grid,
  Button,
  Typography,
  Stack,
  Card,
  CardContent,
} from '@arquivei/atenas';
import { CardActions, CardMedia } from '@mui/material';

import { helpActions } from './helpStartData';

const HelpStart = () => {
  return (
    <Box component="section" data-testid="helpstart-section">
      <Grid container>
        <Grid xs={12} sx={{ pt: { xs: 3, md: 9 } }} mb={5}>
          <Typography level="display2" mb={3}>
            Conte com nossa ajuda para começar
          </Typography>
          <Typography textColor="text.secondary" sx={{ maxWidth: '660px' }}>
            Tire suas dúvidas com nosso material de apoio para desenvolvedores e
            comece agora mesmo a testar nossa API.
          </Typography>
        </Grid>
      </Grid>

      <Grid container pt={3} spacing={3}>
        {helpActions.map(
          ({ title, alt, description, image, link, linkText }) => {
            return (
              <Grid key={title}>
                <Card
                  data-testid="meetups-card"
                  sx={{
                    p: 0,
                    maxWidth: { xs: '100%', sm: '330px' },
                    height: '100%',
                    boxShadow: 'none',
                  }}
                  variant="outlined"
                >
                  <Stack height="100%" justifyContent="space-between">
                    <Stack>
                      <CardMedia
                        component="img"
                        image={image.src}
                        width={image.width}
                        height={image.height}
                        alt={alt}
                        sx={(theme) => ({
                          objectFit: 'none',
                          backgroundColor: theme.palette.grey[300],
                          minHeight: '140px',
                        })}
                      />

                      <CardContent sx={{ p: 2 }}>
                        <Typography gutterBottom level="h4" fontWeight="md">
                          {title}
                        </Typography>
                        <Typography level="body2">{description}</Typography>
                      </CardContent>
                    </Stack>
                    <Stack>
                      <CardActions>
                        <Button
                          component="a"
                          href={link}
                          sx={{
                            backgroundColor: 'white',
                            color: '#FF4719',
                            '&:hover:not(.Joy-focused)': {
                              color: '#D13200',
                              backgroundColor: 'white',
                            },
                            fontWeight: 500,
                          }}
                        >
                          {linkText}
                        </Button>
                      </CardActions>
                    </Stack>
                  </Stack>
                </Card>
              </Grid>
            );
          },
        )}
      </Grid>
    </Box>
  );
};

export default HelpStart;
